(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FarmFetchOffers = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var LEGACY_PRODUCT_HANDLES = [
    'everyday-beef',
    'everyday-chicken',
    'everyday-pork',
    'everyday-fish',
    'everyday-turkey',
    'superfood-topper-chicken',
    'superfood-topper-beef',
    'superfood-topper-sardine',
    'superfood-topper-pork',
    'starter-variety-pack'
  ];
  var LEGACY_COLLECTION_HANDLE = 'fresh-everyday-meal';
  var LEGACY_OFFER_SOURCE = 'legacy-website-ad';

  function pathSegments(pathname) {
    return String(pathname || '')
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(Boolean);
  }

  function isLegacyAdLanding(pathname) {
    var segments = pathSegments(pathname);
    var collectionIndex = segments.indexOf('collections');
    var productIndex = segments.indexOf('products');

    if (collectionIndex !== -1 && segments[collectionIndex + 1] === LEGACY_COLLECTION_HANDLE) return true;
    return productIndex !== -1 && LEGACY_PRODUCT_HANDLES.indexOf(segments[productIndex + 1]) !== -1;
  }

  function hasLegacyOfferMarker(cart, sessionValue) {
    var attributes = cart && cart.attributes ? cart.attributes : {};
    return sessionValue === LEGACY_OFFER_SOURCE || attributes._farmfetch_offer_source === LEGACY_OFFER_SOURCE;
  }

  function hasLegacyProductItem(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) {
      return LEGACY_PRODUCT_HANDLES.indexOf(item && item.handle) !== -1;
    });
  }

  function shouldHaveLiverGift(state) {
    if (!state.hasPaidTrigger || state.hasLiverRedemption) return false;
    return Boolean(
      state.isFirstOrderCustomer ||
      (state.hasSubscription && state.isFirstSubscriptionEligible)
    );
  }

  function shouldHaveLickMatGift(state) {
    if (!state.hasPaidTrigger) return false;
    if (state.hasSubscription) {
      return Boolean(state.isFirstSubscriptionEligible && !state.hasLickMatRedemption);
    }
    return Boolean(
      state.isLegacyOfferConfigured &&
      state.hasLegacyOfferMarker &&
      state.hasLegacyProduct &&
      state.isFirstOrderCustomer &&
      !state.hasLickMatRedemption
    );
  }

  function hasStarterVarietyPack(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) {
      return item && item.handle === 'starter-variety-pack';
    });
  }

  function isGiftUnitCovered(item) {
    if (!item) return false;
    var quantity = Number(item.quantity || 0);
    var originalLinePrice = Number(item.original_line_price);
    var finalLinePrice = Number(item.final_line_price);
    if (quantity < 1 || !Number.isFinite(originalLinePrice) || !Number.isFinite(finalLinePrice)) return false;
    if (originalLinePrice === 0 && finalLinePrice === 0) return true;
    return originalLinePrice - finalLinePrice >= originalLinePrice / quantity;
  }

  function discountRedirect(code, currentPath) {
    var cleanCode = String(code || '').trim();
    var destination = String(currentPath || '/');
    if (!cleanCode) return '';
    if (destination.charAt(0) !== '/') destination = '/' + destination;
    return '/discount/' + encodeURIComponent(cleanCode) + '?redirect=' + encodeURIComponent(destination);
  }

  return {
    LEGACY_PRODUCT_HANDLES: LEGACY_PRODUCT_HANDLES,
    LEGACY_COLLECTION_HANDLE: LEGACY_COLLECTION_HANDLE,
    LEGACY_OFFER_SOURCE: LEGACY_OFFER_SOURCE,
    isLegacyAdLanding: isLegacyAdLanding,
    hasLegacyOfferMarker: hasLegacyOfferMarker,
    hasLegacyProductItem: hasLegacyProductItem,
    hasStarterVarietyPack: hasStarterVarietyPack,
    shouldHaveLiverGift: shouldHaveLiverGift,
    shouldHaveLickMatGift: shouldHaveLickMatGift,
    isGiftUnitCovered: isGiftUnitCovered,
    discountRedirect: discountRedirect
  };
});
